import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logoAuth from '../../assets/logoAuth.GIF'; // Corrected import
import { useAuth } from '../../components/authProvider';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { setToken } = useAuth();
  const navigate = useNavigate();

  const loginUser = async (event) => {
    event.preventDefault();
    console.log('Start Fetch');
    let response;
    try {
      response = await fetch('https://fusionsmart.seifeddineslimene.com/api/login', {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });
    } catch {
      alert(
        'Cannot reach API (network error). Start the server from server/ (default port 5000).'
      );
      return;
    }
    const data = await response.json();
    if (data.success) {
      navigate('/', { replace: true });
      setToken(data.token);
    } else {
      alert('Invalid email or password');
    }
  };
  return (
    <div
      className='flex flex-col items-center justify-center h-screen'
      style={{
        backgroundSize: 'cover',
      }}
    >
      <div className='text-center'>
        <img
          className='w-80 h-70 mb-auto sm:mb-20 mx-auto min-w-[150px] col-6 mx-auto text-center'
          src={logoAuth}
          alt='logo'
        />
        <form
          onSubmit={loginUser}
          className='d-flex flex-column  user ms-20 mb-5 row'
          style={{ width: '90%' }}
        >
          <div className='mb-8'>
            <h1 className='text-3xl  mt-4 mb-2 text-gray-600 text-left'>
              Login
            </h1>
          </div>
          <div className='col-6 mx-auto text-center mb-4'>
            <label className='block   me-2 mb-1'>Email</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder='Email'
              type='email'
              className='w-75 px-4 py-4 border rounded-lg mb-4'
            />
          </div>
          <div className='col-6 mx-auto text-center mb-4'>
            <label className='block   me-2 mb-1'>Password</label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder='Password'
              type='password'
              className='w-75 px-4 py-4 border rounded-lg mb-4'
            />
          </div>
          <div className='flex justify-between items-center'>
            <button
              type='submit'
              className='bg-primary text-white py-2 px-4 rounded border border-0 fw-bold ms-5'
            >
              Login
            </button>
            </div>
            <Link
              className='text-sm text-gray-600 cursor-pointer right mb-4  ms-4'
              to='/forgetpassword'
            >
              Forget password ?
            </Link>
         
        </form>
      </div>
    </div>
  );
};

export default Login;
